 import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./Connections.css";
import apiClient from "../../api/apiClient.js";
import { useConfirm } from "../../context/confirmContext";

function Connections({ userId, setHeaderTitle }) {
    const confirm = useConfirm();
    const { id } = useParams();
    const [friends, setFriends] = useState("");
    const [friendsProfiles, setFriendsProfiles] = useState("");
    const [pendingFriends, setPendingFriends] = useState("");
    const [pendingFriendsProfiles, setPendingFriendsProfiles] = useState("");
    const [friendRequests, setFriendRequests] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [friendRequestsProfiles, setFriendRequestsProfiles] = useState(""); 
    const [showConnections, setShowConnections] = useState(true);
    const [showConnectionRequests, setShowConnectionRequests] = useState(false);
    const navigate = useNavigate(); // Initialize useNavigate
    const [activeTable, setActiveTable] = useState("requests");
    const [licenses, setLicenses] = useState([]);

    //add friend
    const addFriend = async (event) => {
        event.preventDefault();
        const response = await apiClient.post(`/user/request-friend`, {
            friendId: id,
            userId: userId,
        });
        setPendingFriends((prevPendingFriends) => [...prevPendingFriends, id]);
    };

    const deleteFriend = async (friendId) => {
        const ok = await confirm({
            title: "Remove Connection",
            message: "Are you sure you want to remove this connection?",
            confirmLabel: "Remove",
            variant: "danger",
        });
        if (!ok) return;
        await apiClient.post(`/user/delete-friend`, {
            friendId: friendId,
            userId: userId,
        });
        window.location.reload();
    };

    //accept friend request
    const acceptFriend = async (friendId) => {
        apiClient
            .post(`/user/accept-friend`, {
                friendId: friendId,
                userId: userId,
            })
            .then(() => {
                window.location.reload();
            });
    };

    //decline friend Request
    const declineFriend = async (friendId) => {
        const response = await apiClient.post(`/user/decline-friend`, {
            friendId: friendId,
            userId: userId,
        });
        window.location.reload();
    };

    const toggleConnectionRequests = () => {
        setShowConnections(false);
        setShowConnectionRequests(true);
        setActiveTable("connections");
    };

    const toggleConnections = () => {
        setShowConnectionRequests(false);
        setShowConnections(true);
        setActiveTable("connectionRequests");
    };

    const getUserInfo = async () => {
        try {
            const response = await apiClient.get(`/user/get-user-info`);
            const currentUser = await response.data;
            setFriends(currentUser.friends);
            setFriendRequests(currentUser.friendRequests);
            setPendingFriends(currentUser.pendingFriends);

            // Fetch licenses for each license number in currentUser.licenses
            const licensePromises = currentUser.licenseNo.map((licenseNo) =>
                apiClient.get(`/license/get-by-license/${licenseNo}`)
            );

            // Wait for all license requests to complete
            const licenseResponses = await Promise.all(licensePromises);

            // Extract data from each response
            const licensesData = licenseResponses.map((response) => response.data);

            // Store all licenses in the state variable
            setLicenses(licensesData);
        } catch (error) {
            console.error("Error fetching user info:", error);
        }
    };

    let count = 0;
    useEffect(() => {
        if (count === 0) {
            count++;
            getUserInfo();
            setHeaderTitle("Connections");
        }
        return () => {};
    }, []);

    //fetches all friend information to fill friends list
    useEffect(() => {
        if (friends.length > 0) {
            const fetchProfiles = async () => {
                const profiles = await Promise.all(
                    friends.map(async (friendId) => {
                        const response = await apiClient.get(`/user/get-user-info`);
                        return response.data;
                    })
                );

                setFriendsProfiles(profiles);
            };

            fetchProfiles();
        }

        if (friendRequests.length > 0) {
            const fetchPendingProfiles = async () => {
                const profiles = await Promise.all(
                    friendRequests.map(async (friendId) => {
                        const response = await apiClient.get(`/user/get-user-info`);
                        return response.data;
                    })
                );
                setFriendRequestsProfiles(profiles);
            };

            fetchPendingProfiles();
        }

        if (pendingFriends.length > 0) {
            const fetchPendingProfiles = async () => {
                const profiles = await Promise.all(
                    pendingFriends.map(async (friendId) => {
                        const response = await apiClient.get(`/user/get-user-info`);
                        return response.data;
                    })
                );
                setPendingFriendsProfiles(profiles);
            };

            fetchPendingProfiles();
        }
    }, [friends]);

    return (
        <div className="connections-container fade-down">
            {userId === id && (
                <div
                    className="profiles-section"
                    style={{
                        display: "flex",
                        justifyContent: "spaceBetween",
                        width: "80%",
                    }}
                >
                    <button
                        onClick={toggleConnections}
                        className={`profiles-button-1 ${activeTable === "connections" ? "active-1" : ""}`}
                        style={{ fontSize: "1.2rem" }}
                    >
                        Connections
                    </button>
                    <button
                        onClick={toggleConnectionRequests}
                        className={`profiles-button-1 ${activeTable === "connectionRequests" ? "active-1" : ""} ${
                            friendRequests.length > 0 ? "red-background" : ""
                        }`}
                        style={{
                            fontSize: "1.2rem",
                        }}
                    >
                        Requests ({friendRequests.length})
                    </button>
                </div>
            )}
            {showConnectionRequests && userId === id && (
                <div className="friends-list">
                    <div className="friends" style={{ flex: 1, marginLeft: "1vw" }}>
                        <h2 className="friend-requests">Connection Requests</h2>
                        {friendRequestsProfiles && friendRequestsProfiles.length > 0 && (
                            <div style={{ overflowY: "auto", maxHeight: "50vh", width: "80vw" }}>
                                <table className="PendingFriendsUsers" style={{ overflow: "auto", width: "100%" }}>
                                    <tbody>
                                        {friendRequestsProfiles.map((friend, index) => (
                                            <tr key={index} className="table-row-friends">
                                                <td>
                                                    <img
                                                        src="/profileicons/check.svg"
                                                        alt="Accept"
                                                        title="Accept Connection Request"
                                                        onClick={() => acceptFriend(friend.userId)}
                                                        style={{
                                                            cursor: "pointer",
                                                            width: "3vh",
                                                            height: "3vh",
                                                            border: "1px solid var(--primaryBorder)",
                                                            borderRadius: "50%",
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <img
                                                        src="/profileicons/close.svg"
                                                        alt="Decline"
                                                        title="Decline Connection Request"
                                                        onClick={() => declineFriend(friend.userId)}
                                                        style={{
                                                            cursor: "pointer",
                                                            width: "3vh",
                                                            height: "3vh",
                                                            border: "1px solid var(--primaryBorder)",
                                                            borderRadius: "50%",
                                                        }}
                                                    />
                                                </td>
                                                <td
                                                    style={{
                                                        width: "20vw",
                                                        textAlign: "left",
                                                        padding: "1vh 1vw",
                                                        fontWeight: "bold",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    <div
                                                        onClick={() => {
                                                            navigate(`/userProfile/${friend.userId}`);
                                                        }}
                                                        className="profile-container-username-and-pic"
                                                    >
                                                        {!friend.profilePic && (
                                                            <img
                                                                src="/ProfilePicDefault.svg"
                                                                alt="Profile"
                                                                className="profile-pic-container-1"
                                                            />
                                                        )}
                                                        {friend.profilePic && (
                                                            <img
                                                                src={friend.profilePic}
                                                                alt="Profile"
                                                                className="profile-pic-container-1"
                                                                style={{ width: "1vw" }}
                                                            />
                                                        )}
                                                        <button
                                                            onClick={() => {
                                                                navigate(`/userProfile/${friend.userId}`);
                                                            }}
                                                            className="go-to-friend"
                                                        >
                                                            {friend.firstName} {friend.lastName}
                                                        </button>
                                                    </div>
                                                </td>
                                                <td style={{ padding: "1vh 1vw" }}>{friend.title}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {showConnections && userId === id && (
                <div className="friends-list" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div
                        className="friends"
                        style={{
                            flex: 1,
                            marginRight: "1vw",
                            maxHeight: "50vh",
                            marginBottom: "2vh",
                        }}
                    >
                        <h2 className="friends-list-header">Connections</h2>
                        {friendsProfiles && friendsProfiles.length > 0 && (
                            <div
                                style={{
                                    overflowY: "auto",
                                    maxHeight: "45vh",
                                    minHeight: "45vh",
                                    width: "80vw",
                                    marginTop: "20px",
                                }}
                            >
                                <table className="PendingFriendsUsers" style={{ marginTop: "3vh", width: "50vw" }}>
                                    <tbody className="friends-list-body">
                                        {friendsProfiles.map((friend, index) => {
                                            if (!friend) return null; // Skip null items
                                            return (
                                                <tr key={index} className="table-row-friends">
                                                    <td>
                                                        <img
                                                            src="/profileicons/remove.svg"
                                                            alt="Remove"
                                                            title="Remove Connection"
                                                            onClick={() => deleteFriend(friend.userId)}
                                                            style={{
                                                                cursor: "pointer",
                                                                width: "3vh",
                                                                height: "3vh",
                                                            }}
                                                        />
                                                    </td>
                                                    <td
                                                        style={{
                                                            width: "25vw",
                                                            textAlign: "left",
                                                            padding: "1vh 1vw",
                                                            fontWeight: "bold",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        <div
                                                            onClick={() => {
                                                                navigate(`/userProfile/${friend.userId}`);
                                                            }}
                                                            className="profile-container-username-and-pic"
                                                        >
                                                            {!friend.profilePic && (
                                                                <img
                                                                    src="/ProfilePicDefault.svg"
                                                                    alt="Profile"
                                                                    className="profile-pic-container-1"
                                                                />
                                                            )}
                                                            {friend.profilePic && (
                                                                <img
                                                                    src={friend.profilePic}
                                                                    alt="Profile"
                                                                    className="profile-pic-container-1"
                                                                    style={{ width: "1vw" }}
                                                                />
                                                            )}
                                                            <button
                                                                onClick={() => {
                                                                    navigate(`/userProfile/${friend.userId}`);
                                                                }}
                                                                className="go-to-friend"
                                                            >
                                                                {friend.firstName} {friend.lastName}
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td style={{ padding: "1vh 2vw", width: "30vw" }}>
                                                        {friend.title}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default Connections;
